import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getRubrosPanel = async (searchTerm,searchFilter, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`descripcion_rubro=${encodeURIComponent(searchTerm || '')}`);
    }
    if (searchFilter) {
        queryParams.push(`ramo_id=${encodeURIComponent(searchFilter || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/rubros", queryString);
};


export const getRubroById = async (id) => {
    const res = await getData(`/rubros/${id}`)
    return res
}

export const postRubro = async (body) => {
    const res = await postData('/rubros', body)
    return res
}

export const patchRubro = async (id, body) => {
    const res = await patchData(`/rubros/${id}`, body)
    return res
}

export const deleteRubro = async (id) => {
    const res = await deleteData(`/rubros/${id}`)
    return res
}
 